var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-up-down',{attrs:{"active":_vm.shouldShow,"duration":500}},[_c('div',{staticClass:"loader"},[_c('img',{staticClass:"image",attrs:{"src":(_vm.appUrl + "assets/img/u-loader.gif"),"alt":"adatok letöltése folyamatban..."}})])])}
var staticRenderFns = []

export { render, staticRenderFns }